import { format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '../../ui/ConfirmModal';
import { CalendarDays } from '../../ui/Icon';
import { useDateLocale } from '../../../utils/dateLocale';
import type { Activity, ItineraryDay } from '../../../types';

/**
 * Asked after a stop is dropped on a day chip. Only there: in the list view the
 * card leaves the day on screen for one the user cannot see, so a wrong chip is
 * noticed late, if at all. Timeline and Routes show where the card lands, and
 * the undo toast (ADR-0015) covers them.
 */
export function ConfirmDayMove({ moving, target, onConfirm, onCancel }: {
  moving: Activity[];
  target: ItineraryDay | null;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation();
  const dateLocale = useDateLocale();
  const open = target !== null && moving.length > 0;

  return (
    <ConfirmModal
      open={open}
      tone="neutral"
      icon={CalendarDays}
      title={open
        ? t('itinerary.move.confirmTitle', {
          count: moving.length,
          title: moving[0].title,
          day: target.dayNumber,
        })
        : ''}
      body={open ? format(parseISO(target.date.slice(0, 10)), 'EEEE d MMMM', { locale: dateLocale }) : undefined}
      confirmLabel={t('itinerary.move.confirm')}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
